<template>

  <header class="sticky-header">
    <!-- Navigation bar -->
    <nav class="navbar navbar-expand-lg navbar-dark bg-dark pt-lg-3 sticky-top"> <!-- bg-body-tertiary -->
      <div class="container-fluid"> <!-- container-fluid -->
        <a class="navbar-brand fs-2 fw-bold font-custom" href="/">
          <color_yellowgreen>Cannon</color_yellowgreen><color_orange>ball</color_orange>
        </a>
        <img src="@/assets/logo_invertiert_rgb.png" alt="Logo" class="img-fluid" style="max-height: 40px;">
        <button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
          <span class="navbar-toggler-icon"></span>
        </button>
        <div class="collapse navbar-collapse" id="navbarSupportedContent">
          <ul class="navbar-nav ms-auto mb-2 mb-lg-0">
            <li class="nav-item">
              <a class="nav-link active"><router-link to="/">Home</router-link></a>
            </li>
            <li class="nav-item">
              <a class="nav-link active"><router-link to="/about">Über uns</router-link></a>
            </li>
            <li class="nav-item">
              <a class="nav-link active"><router-link to="/contact">Kontakt</router-link></a>
            </li>
            <li class="nav-item">
              <a class="nav-link active"><router-link to="/intern">Intern</router-link></a>
            </li>
          </ul>
        </div>
      </div>
    </nav>
  </header>
  
  <router-view/>

  <!-- Footer -->
  <div class="footer py-1">
    &copy; 2026 Cannonball
  </div>
</template>

<style>
  #app {
    font-family: 'Yanone Kaffeesatz', sans-serif; /*Avenir, Helvetica, Arial, sans-serif;*/
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: center;
    color: #2c3e50;
  }

  nav {
    padding: 30px;
    border-bottom: 2px solid #888;
  }

  nav a {
    font-weight: bold;
    color: #0f6fff; /*#2c3e50;*/
  }

  nav a.router-link-exact-active {
    color: #42b983;
  }

   color_yellowgreen {
    color: yellowgreen;
  }

  color_orange {
    color: orangered;
  }

  .font-custom {
    font-family: 'Yanone Kaffeesatz', sans-serif;
    /* not necessary, because installed via npm, see fontsource.org */
    /* src: url('@/assets/fonts/YanoneKaffeesatz-Regular.ttf');*/  /* format('ttf');*/
    /*src: url('./assets/fonts/yanone-kaffeesatz-latin-400-normal.ab9592a2.woff2') format('woff2'),
         url('assets/fonts/YanoneKaffeesatz-Regular.ttf');*/
    font-weight: normal;
    font-style: normal;
  }  

  body {
    font-family: 'Yanone Kaffeesatz', sans-serif;
    font-size: 1.3rem;
    background-color: bg-dark;
  }

  .footer {
    border-top: 1px solid #888;
    border-bottom: 1px solid #888;
    font-family: sans-serif;
    font-size: 1rem;
  }

  .sticky-header {
  position: sticky; /* Das Herzstück! */
  top: 0;
  width: 100%;
  /*background-color: #333;*/
  /*color: white;*/
  /*padding: 1rem;*/
  z-index: 100; /* Sorgt dafür, dass er über anderen Inhalten liegt */
  box-shadow: 0 2px 5px rgba(0,0,0,0.2);
}

</style>

<script>

</script>
